var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('portal-target',{attrs:{"name":"modals"}}),(_vm.app.showPreloader)?_c('div',{staticClass:"app-preloader"},[_c('div',{staticStyle:{"position":"flex"}},[_c('h2',[_vm._v(_vm._s(_vm.app.title))])]),_c('div',{staticClass:"app-loader"})]):_vm._e(),_c('layout',{attrs:{"blocks":_vm.blocks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }